import { FeatureFlag } from '../FeatureFlag';

/**
 * Enables updated-cell flashes on the new owned grid (ADR 0014): cells whose value actually
 * changes get a honey-yellow wash that fades out. Consumed wherever the new grid renders behind
 * a new-grid rollout flag (Results, alpha scans, Aggregated Risk, Watchlist, LAB v2 Cost Info,
 * SearchAlpha, Screener, Scanner, Blotter, and Messages); it has no effect while the corresponding
 * replacement grid is off.
 *
 * A new capability, not parity: production never enabled ag-grid's cell change flash.
 */
export const enableGridCellFlash = new FeatureFlag({
    key: 'enable-grid-cell-flash',
    createdOn: '2026-07-07',
    defaultValue: false,
});
